import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { TrashIcon } from 'lucide-react'

interface Props {
  confirmText: string
  successBtnText: string
  cancelBtnText?: string
  onSuccess: () => void
  openBtnText?: string
  isDisabled?: boolean
  onCancel?: () => void
}

export default function ButtonConfirmDelet({
  successBtnText,
  cancelBtnText = 'Cancelar',
  openBtnText,
  confirmText,
  isDisabled,
  onSuccess,
  onCancel
}: Props) {
  const [open, setOpen] = useState(false)

  const handleClose = () => setOpen(false)

  const handleSuccess = () => {
    onSuccess()
    handleClose()
  }

  const handleCancel = () => {
    handleClose()
    if (onCancel) onCancel()
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          disabled={isDisabled}
          // não precisa de onClick, o PopoverTrigger já cuida do toggle
        >
          <TrashIcon className="h-4 w-4 text-red-500" />
          {openBtnText}
        </Button>
      </PopoverTrigger>

      <PopoverContent className="max-w-xs">
        <p className="text-sm">{confirmText}</p>

        <div className="flex justify-end mt-2 gap-2">
          <Button variant="outline" size="sm" onClick={handleCancel}>
            {cancelBtnText}
          </Button>
          <Button variant="destructive" size="sm" onClick={handleSuccess}>
            {successBtnText}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  )
}
